import { FormItemLabel, StyledCreateFoodForm } from "./styled"
import PortionWithUnitTextField from "components/portion/PortionWithUnitTextField"
import NutrientInformation from "components/foodDetails/share/NutrientInformation"
import EdamaIngredients from "./EdamaIngredients"
import ImageUploader from "components/inputs/ImageUploader"
import TextAreaFieldFormItem from "components/inputs/TextAreaFieldFormItem"
import { IMyFoodFormModel } from "model/food/types/foodPayload.types"
import { IEdamaIngredientOption } from "model/food/types/edama.types"

interface Iprops {
  showSearchIngredients: () => void
  myFood: IMyFoodFormModel
  onNameChange: (name: string) => void
  onPortionChange: (portion: number) => void
  onUnitChange: (unit: string) => void
  onRemoveIngredient: (id: string) => void
  onViewIngredientDetails: (food: IEdamaIngredientOption) => void
  setIsPortionValid?: (isValid: boolean) => void
}

const CreateMyFoodForm = (props: Iprops) => {
  const {
    myFood,
    showSearchIngredients,
    onNameChange,
    onPortionChange,
    onUnitChange,
    onRemoveIngredient,
    onViewIngredientDetails,
    setIsPortionValid,
  } = props

  return (
    <StyledCreateFoodForm>
      <TextAreaFieldFormItem
        label="Name"
        placeholder="Name your meal"
        value={myFood.name}
        onChange={onNameChange}
      />

      <PortionWithUnitTextField
        portionValue={myFood.portion}
        unitValue={myFood.unit}
        onUnitChange={onUnitChange}
        onPortionChange={onPortionChange}
        setIsPortionValid={setIsPortionValid}
        calories={myFood.calorie}
        gram={myFood.gram}
      />

      <NutrientInformation entry={myFood} />

      <EdamaIngredients
        showSearchIngredients={showSearchIngredients}
        ingredients={myFood.ingredients}
        onRemoveIngredient={onRemoveIngredient}
        onViewIngredientDetails={onViewIngredientDetails}
      />

      <div>
        <FormItemLabel>
          Image <span>{"(optional)"}</span>
        </FormItemLabel>
        <ImageUploader />
      </div>
    </StyledCreateFoodForm>
  )
}

export default CreateMyFoodForm
